import { AlignItems } from '@payflip/types/product-builder';
import styled from 'styled-components';

export const Column = styled.div<{
  alignItems?: AlignItems;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: ${({ alignItems = 'stretch' }): string => alignItems};
`;
